import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "filter-check" }

import { ref } from 'vue'
import FilterCheckbox from '@/components/setup/FilterCheckbox.vue'
import type { CommonRadioFilterType } from '@/types/filter'


export default /*@__PURE__*/_defineComponent({
  __name: 'CommonRadioFilters',
  props: {
    filters: {}
  },
  emits: ["updated", "summary"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const selected = ref()

const filter = Object.values(props.filters)[0]
const filterName = Object.keys(props.filters)[0]

const filtersToEmit = ref<Record<string, boolean | string>>({})
const changeTypeFilter = (key: string, e: boolean | string) => {
  filtersToEmit.value[key] = e
}

const emits = __emit

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filter), (value, key) => {
      return (_openBlock(), _createBlock(FilterCheckbox, {
        key: key,
        label: value.label,
        icons: value.icons,
        "model-value": selected.value === key,
        onClick: 
          (e) => {
            selected.value = key
            changeTypeFilter(_unref(filterName), e.target.checked ? value.value : false)
            emits('updated', filtersToEmit.value)
            emits('summary', e.target.checked ? value.summary : '')
          }
        
      }, null, 8, ["label", "icons", "model-value", "onClick"]))
    }), 128))
  ]))
}
}

})